<template>
  <!-- 回到顶部 -->
  <div class="go-top" v-show="isTop">
    <!-- <img class="top-img" src="@/assets/img/logo/logo3.png" alt="" /> -->
    <!-- <div @mouseover="showFloat" @mouseleave="hideFloat" class="top-list img1">
      <img src="./qr.png" alt="" />
      <div>{{ $t("back-top.download") }}</div>
    </div>

    <div class="top-list img5" @click="toFeedBack" v-show="language == 'zh-CN'">
      <img src="./feedback.png" alt="" />
      <div>{{ $t("back-top.feedback") }}</div>
    </div>
    <div @click="toService()" class="top-list img3" v-show="language == 'zh-CN'">
      <img src="./server.png" alt="" />
      <div>{{ $t("back-top.service") }}</div>
    </div> -->
    <div @click="goTop()" class="top-list img4">
      <img src="./go-top.png" alt="" />
      <div>{{ $t("back-top.to-top") }}</div>
    </div>

    <div @mouseover="showFloat" @mouseleave="hideFloat" v-show="isDownload" class="download">
      <qriously v-if="appConfig.h5_domain" :value="appConfig.h5_domain ? appConfig.h5_domain + 'download' : ''" :size="74" />
      <div class="download-desc">{{ $t("back-top.download-desc") }}</div>
      <router-link to="/download" target="_blank" @click="toDownload()" class="download-btn">{{ $t("back-top.download1") }}</router-link>
    </div>

    <div v-show="isPublic" class="public">
      <qriously v-if="appConfig.weibo" :value="appConfig.weibo" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "go-top",
  props: {},
  data() {
    return { isDownload: false, isPublic: false, isTop: false, timer: null, language: localStorage.getItem("language") };
  },
  computed: {
    ...mapState(["appConfig"]),
  },
  mounted() {
    window.addEventListener("scroll", this.paperScroll);
  },
  destroyed() {
    //离开该页面需要移除这个监听的事件
    window.removeEventListener("scroll", this.paperScroll);
  },
  methods: {
    showFloat() {
      clearTimeout(this.timer);
      this.isDownload = true;
    },
    hideFloat() {
      this.timer = setTimeout(() => {
        this.isDownload = false;
      }, 100);
    },
    toFeedBack() {
      //this.$router.push("/about/3");
      window.location.href="/about/3";
    },

    toService() {
      window.open(this.appConfig.service_url, "_blank");
    },
    goTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    paperScroll() {
      let tpScrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset;
      // console.log(tpScrollTop);
      if (tpScrollTop > 400) {
        this.isTop = true;
      } else {
        this.isTop = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.go-top {
  width: 0.52rem;
  padding: 0.1rem 0;
  border-radius: 0.05rem;
  position: fixed;
  // float: right;
  right: 0.3rem;
  bottom: 2.35rem;
  margin-right: 0.3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  background-color: #fff;
  z-index: 999;
}
.top-img {
  width: 0.79rem;
  height: 0.64rem;
  position: absolute;
  top: -0.58rem;
  left: -0.13rem;
}
.top-list {
  color: #FF2929;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  & img {
    margin-bottom: 0.03rem;
    width: 0.2rem;
    height: 0.2rem;
  }
  &:hover {

    color: #FF2929;
  }
}
.img1:hover img {
  content: url("./qr_hover.png");
}
.img2:hover img {
  content: url("./public_hover.png");
}
.img3:hover img {
  content: url("./server_hover.png");
}
.img4:hover img {
  content: url("./top_hover.png");
}
.img5:hover img {
  content: url("./feedback_hover.png");
}
.download {
  // width: 1rem;
  // height: 1.5rem;
  padding: 0.08rem 0.04rem;
  border: 2px solid var(--border-primary);
  border-top: 4px solid var(--border-primary);
  border-radius: 0.05rem;
  position: absolute;
  top: 0px;
  left: -1.39rem;
  background-color: #fff;
  color: #999;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.12rem;

  .download-desc {
    width: 1.2rem;
    margin-bottom: 0.05rem;
    line-height: 0.2rem;
    text-align: center;
  }
  .download-btn {
    // width: 0.65rem;
    height: 0.22rem;
    padding: 0 0.05rem;
    background-color: var(--theme-primary);
    border: 1px solid var(--border-primary);
    border-radius: 0.22rem;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  &:after,
  &:before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border: 0.08rem solid transparent;
    border-left-color: var(--border-primary);
    top: 0.2rem;
    // margin-left: -4px;
    right: -0.18rem;
  }
  &:after {
    border-left-color: #fff;
    right: -0.16rem;
  }
}
.public {
  width: 1rem;
  height: 0.95rem;
  padding: 0.1rem;
  border: 2px solid var(--border-primary);
  border-top: 4px solid var(--border-primary);
  border-radius: 0.05rem;
  position: absolute;
  top: 0.5rem;
  left: -1.08rem;
  background-color: #fff;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;

  &:after,
  &:before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border: 0.08rem solid transparent;
    border-left-color: var(--border-primary);
    top: 0.2rem;
    right: -0.18rem;
  }

  &:after {
    border-left-color: #fff;
    right: -0.16rem;
  }
}
::v-deep canvas {
  width: 1rem !important;
  // height: 0.74rem !important;
}
</style>
